import React from 'react';
import { Box, HStack, Button } from '@chakra-ui/react';
import { motion, AnimateSharedLayout } from 'framer-motion';

export interface SegmentedControlOption {
    label: string;
    value: string | number;
}

interface SegmentedControlProps {
    options: SegmentedControlOption[];
    value: string | number;
    onChange: (value: any) => void;
    size?: 'xs' | 'sm' | 'md';
    activeColor?: string;
    layoutId?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
    options,
    value,
    onChange,
    size = 'sm',
    activeColor = 'purple.600',
    layoutId = 'segmented-control-active',
}) => {
    const isXs = size === 'xs';
    const height = isXs ? 8 : 10;
    const fontSize = isXs ? 'xs' : 'sm';

    return (
        <Box bg="gray.100" _dark={{ bg: 'whiteAlpha.50' }} p={1} borderRadius="xl" position="relative">
            <AnimateSharedLayout>
                <HStack spacing={0} position="relative">
                    {options.map((opt) => {
                        const isActive = value === opt.value;
                        return (
                            <Button
                                key={opt.value}
                                flex={1}
                                size={size}
                                variant="unstyled"
                                h={height}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                fontSize={fontSize}
                                position="relative"
                                onClick={() => onChange(opt.value)}
                                color={isActive ? activeColor : 'gray.500'}
                                fontWeight={isActive ? 'bold' : 'medium'}
                                _hover={{
                                    color: isActive ? activeColor : 'purple.500',
                                }}
                                transition="color 0.2s"
                            >
                                {isActive && (
                                    <motion.div
                                        layoutId={layoutId}
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                            zIndex: 1,
                                        }}
                                        transition={{
                                            type: "spring",
                                            stiffness: 400,
                                            damping: 30
                                        }}
                                    />
                                )}
                                <Box as="span" position="relative" zIndex={2}>
                                    {opt.label}
                                </Box>
                            </Button>
                        );
                    })}
                </HStack>
            </AnimateSharedLayout>
        </Box>
    );
};
